import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
// import {
//   UncontrolledButtonDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from "reactstrap";
// import axios from "axios";
import { getKaizens } from "./../../services/kaizens";
import { getActions } from "./../../services/actions";
import { deleteWasteType } from "./../../services/wastetypes";
import { getRootCauses } from "./../../services/rootcauses";
import "bootstrap/dist/css/bootstrap.min.css";
//import FloatSubMenu from './../../components/float-sub-menu/float-sub-menu';
import Pagination from "../../common/pagination";
import { paginate } from "../../utils/paginate";
import KaizensTable from "../../components/kaizensTable.jsx";
import SearchBox from "./../../common/searchBox";
import _ from "lodash";
import http from "./../../services/httpService";
import { apiUrl } from "./../../config/config.json";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import {
//   Col,
//   Button,
//   Form,
//   FormGroup,
//   Input,
//   Modal,
//   Label,
//   ModalHeader,
//   ModalBody,
//   Row,
// } from "reactstrap";

// Icons imports
import newIcon from "../../assets/Icons/new.svg";
import editIcon from "../../assets/Icons/edit.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import sharingIcon from "../../assets/Icons/sharing.svg";

import Icon from "./../../common/icon";
import { getWasteTypes } from "./../../services/wastetypes";
import WasteTypesTable from "../../components/wastetypes.jsx";

class WasteTypesDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wastetypes: [],
      checkedwastetypes: [],
      pageSize: 10,
      currentPage: 1,
      sortColumn: { path: "title", order: "asc" },
      searchQuery: "",
      errors: {},
    };
  }

  async componentDidMount() {
    const data = await getWasteTypes();
    const wastetypesWithPartNames=data.data ?.map((wastetype) => {
      wastetype.participants = wastetype?.participants?.map((part) => {
            return `${part?.username} `;
      });
      return wastetype;
    });
    this.setState({wastetypes:wastetypesWithPartNames})
  }

  handleDelete = (user) => {
    console.log(user);
    const wastetypes = this.state.wastetypes.filter((el) => el._id !== user._id);
    this.setState({ wastetypes: wastetypes });
  };
  //sorting columns
  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };
  handlePageChange = (page) => {
    console.log(page);
    this.setState({ currentPage: page });
  };

  handleSearch = (query) => {
    console.log(query);
    this.setState({ searchQuery: query, currentPage: 1 });
  };

  handleCheckboxChange = ({ target: { checked, value } }) => {
    if (checked) {
      this.setState(({ checkedwastetypes }) => ({
        checkedwastetypes: [...checkedwastetypes, value],
      }));
    } else {
      this.setState(({ checkedwastetypes }) => ({
        checkedwastetypes: checkedwastetypes.filter((e) => e !== value),
      }));
    }
    console.log("checked wastetypes: ", this.state.checkedwastetypes);
  };

  handleMassDelete = (CheckedWasteTypes) => {
    const originalWasteTypes = this.state.wastetypes;
    CheckedWasteTypes.map(async (wastetype) => {
      try {
        await deleteWasteType( wastetype );
        const wastetypes = this.state.wastetypes.filter(
          (WasteType) => WasteType._id !== wastetype
        );
        this.setState({ wastetypes });
      } catch (ex) {
        if (ex.response && ex.response === 404) {
          alert("already deleted");
        }

        this.setState({ wastetypes: originalWasteTypes });
      }
      console.log("WasteTypes: ", this.state.wastetypes);
    });
  };

  getDataPgnation = () => {
    const {
      pageSize,
      currentPage,
      wastetypes: WasteTypes,
      sortColumn,
      searchQuery,
    } = this.state;
    //
    //filter maybe next time
    let filtered = WasteTypes;
    if (searchQuery) {
      console.log(searchQuery);
      filtered = WasteTypes.filter(
        (el) =>
          el.email.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
          el.userID.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    }

    //
    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const wastetypes = paginate(sorted, currentPage, pageSize);
    return { data: wastetypes };
  };

  render() {
    const { length: count } = this.state.wastetypes;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;
    // if(count === 0)  return "<p>No data available</p>";

    const { data: wastetypes } = this.getDataPgnation();

    console.log("waste Types : " , wastetypes)

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/wastetype/wastetypes">WasteTypes</Link>
          </li>
          <li className="breadcrumb-item active">Data Tables</li>
        </ol>
        <h1 className="page-header">WasteTypes </h1>
        <Panel>
          <PanelHeader>WasteTypes Management</PanelHeader>

          <React.Fragment>
            <ToastContainer />
            <div className="toolbar" style={toolbarStyles}>
              <Icon
                to="/kaizen/wastetypes/new"
                title="Add wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={newIcon}
              />
              <Icon
                to={
                  this.state.checkedwastetypes
                    ? `/kaizen/wastetypes/${this.state.checkedwastetypes[0]}`
                    : "/kaizen/wastetypes/"
                }
                title="Edit wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={editIcon}
              />
              <Icon
                to="/kaizen/wastetypes/"
                handleClick={() =>
                  this.handleMassDelete(this.state.checkedwastetypes)
                }
                title="Delete wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={trashIcon}
              />
              <Icon
                to="/wastetype/wastetypes/"
                title="Xlsx wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={xlsIcon}
              />
              <Icon
                to="/wastetype/wastetypes/"
                title="CSV wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={csvIcon}
              />
              <Icon
                to="/wastetype/wastetypes/"
                title="pdf wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={pdfIcon}
              />
              <Icon
                to="/wastetype/wastetypes/"
                title="share wastetype"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={sharingIcon}
              />
            </div>
            <div className="table-responsive">
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <p
                className="page-header float-xl-left"
                style={
                  ({ marginBottom: 5 }, { marginLeft: 20 }, { marginTop: 5 })
                }
              >
                {count} entries
              </p>

              <WasteTypesTable
                wastetypes={this.state.wastetypes}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
                sortColumn={sortColumn}
                handleCheckboxChange={this.handleCheckboxChange}
              />
            </div>
          </React.Fragment>

          <hr className="m-0" />
          <PanelBody>
            <div className="d-flex align-items-center justify-content-center">
              <Pagination
                itemsCount={count}
                pageSize={pageSize}
                onPageChange={this.handlePageChange}
                currentPage={currentPage}
              />
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}
const toolbarStyles = {
  background: "#c8e9f3",
  padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
  width: "25px",
  height: "25px",
  marginRight: "0rem",
};

export default WasteTypesDataTable;